import { Button, Card, Col, Input, Row, Space, Typography } from "antd"
import {
  PlusOutlined,
} from "@ant-design/icons";
import QuizQuestionOption from "./option";

const { Text } = Typography

const QuizQuestion = ({
  formKey,
  formLabel = "Add a New Question",
  optionLabel = "Add Option",
  buttonSaveLabel = "Save",
  buttonCancel = "Cancel",
  editable = false,
  questionText,
  optionFields,
  explanation,
  setQuestionText,
  setExplanation,
  handleCorrectRadio,
  handleOptionChange,
  handleAddOption,
  handleSaveQuestion,
  handleRemoveOption,
  handleCancelEdit,
}) => {
  return (
    <Card
      key={formKey || "add-form"}
      size="small"
      style={{
        borderRadius: 8,
        border: "1px solid #e0e0e0",
        boxShadow: "0 1px 2px #0001",
        width: "100%",
        margin: "24px 0",
      }}
      bodyStyle={{ padding: 24 }}
    >
      <Row>
        <Col flex="auto">
          <Text strong style={{ fontSize: 18 }}>
            {formLabel}
          </Text>
        </Col>
      </Row>
      <Input.TextArea
        className="my-2"
        placeholder="Enter your question"
        value={questionText}
        onChange={(e) => setQuestionText(e.target.value)}
        autoSize
        style={{ fontSize: 16, marginBottom: 20 }}
      />
      <div style={{ marginBottom: 24 }}>
        {optionFields?.map((opt, idx) => (
          <QuizQuestionOption
            key={idx}
            index={idx}
            option={opt}
            optionFields={optionFields}
            handleRemoveOption={handleRemoveOption}
            handleOptionChange={handleOptionChange}
            handleCorrectRadio={handleCorrectRadio}
          />
        ))}
        <Button
          onClick={handleAddOption}
          type="dashed"
          icon={<PlusOutlined />}
          block
          style={{
            maxWidth: 700,
            fontSize: 16,
            marginTop: 8,
            marginBottom: 8,
            height: 40,
          }}
        >
          {optionLabel}
        </Button>
      </div>
      <Input.TextArea
        className="my-2"
        placeholder="Feedback for incorrect answers"
        value={explanation}
        onChange={(e) => setExplanation(e.target.value)}
        autoSize
        style={{ fontSize: 16, marginBottom: 24 }}
      />
      <Space size="large" style={{ marginTop: 12 }}>
        <Button
          type="dashed"
          onClick={handleSaveQuestion}
          icon={<PlusOutlined />}
          style={{ fontSize: 16, minWidth: 120 }}
        >
          {buttonSaveLabel}
        </Button>
        {
          // if editing, show cancel button
          editable ? (
            <Button
              onClick={handleCancelEdit}
              style={{ fontSize: 16, minWidth: 100 }}
            >
              {buttonCancel}
            </Button>
          ) : null
        }
      </Space>
    </Card>
  );
};

export default QuizQuestion;